export const PURCHASE_DATE_TOOLTIP_COPY =
  'Purchase date is needed to track the warranty period of the devices, you can add or edit the date in the asset details.';
